"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicStudent = exports.getPublicStudents = exports.deleteStudentRelation = exports.topicStudentRelation = exports.putStudentOrganization = exports.putStudentAccessibility = exports.deleteStudentPermission = exports.postStudentPermission = exports.delStudent = exports.postStudent = exports.putStudent = exports.getStudent = exports.getStudents = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var studentsAuthorizedPath = root_1.lmsAuthorized + '/students/';
var studentsPublicPath = root_1.lmsPublic + '/students/';

var getStudents = function getStudents(authentication, queryParameters) {
  return common_1.get(authentication, studentsAuthorizedPath, queryParameters);
};

exports.getStudents = getStudents;

var getStudent = function getStudent(authentication, id) {
  return common_1.get(authentication, studentsAuthorizedPath + id);
};

exports.getStudent = getStudent;

var putStudent = function putStudent(authentication, student) {
  return common_1.put(authentication, studentsAuthorizedPath + student.id, student);
};

exports.putStudent = putStudent;

var postStudent = function postStudent(authentication, student) {
  return common_1.post(authentication, studentsAuthorizedPath, student);
};

exports.postStudent = postStudent;

var delStudent = function delStudent(authentication, id) {
  return common_1.del(authentication, studentsAuthorizedPath + id);
};

exports.delStudent = delStudent;

var postStudentPermission = function postStudentPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, studentsAuthorizedPath, id, permission);
};

exports.postStudentPermission = postStudentPermission;

var deleteStudentPermission = function deleteStudentPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, studentsAuthorizedPath, id, permissionId);
};

exports.deleteStudentPermission = deleteStudentPermission;

var putStudentAccessibility = function putStudentAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, studentsAuthorizedPath, id, accessibility);
};

exports.putStudentAccessibility = putStudentAccessibility;

var putStudentOrganization = function putStudentOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, studentsAuthorizedPath, id, organizationId);
};

exports.putStudentOrganization = putStudentOrganization;

var topicStudentRelation = function topicStudentRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, studentsAuthorizedPath, id, relation);
};

exports.topicStudentRelation = topicStudentRelation;

var deleteStudentRelation = function deleteStudentRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, studentsAuthorizedPath, id, relationId);
};

exports.deleteStudentRelation = deleteStudentRelation;

var getPublicStudents = function getPublicStudents(authentication, queryParameters) {
  return common_1.get(authentication, studentsPublicPath, queryParameters);
};

exports.getPublicStudents = getPublicStudents;

var getPublicStudent = function getPublicStudent(authentication, id) {
  return common_1.get(authentication, studentsPublicPath + id);
};

exports.getPublicStudent = getPublicStudent;